import moment from "moment";

export default {
    methods: {
        transformToModifierClass(str) {
            if(!str){
                return ''
            }

            return str.toLowerCase().split(' ').join('-')
        },

        transformDateTime(createdTime, showTime = true) {
            if(!createdTime) {
                return '';
            }
            let date = moment(createdTime.value).format('YYYY-MM-DD')
            let time = showTime ? this.transformTime(createdTime.displayValue.split(' ').slice(1).join(' ')) : '';
            let today = moment().format('YYYY-MM-DD')
            let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')

            let transformedDateTime = moment(createdTime.value, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' ' + time;

            switch (date) {
                case today:
                    transformedDateTime = this.$t('LBL_TODAY') + ' ' + time
                    break
                case yesterday:
                    transformedDateTime = this.$t('LBL_YESTERDAY') + ' ' + time
                    break
            }

            return {'value': createdTime.value, 'displayValue': transformedDateTime}
        },

        transformTime(time) {
            let theTime = time.toLowerCase();
            if(theTime.includes('am') || theTime.includes('pm')) {
                let isPM = theTime.includes('pm');
                let timeParts = time.split(/[:|\s]/).slice(0,2);
                let hh = parseInt(timeParts[0]);
                let mm = timeParts[1];

                if(isPM && hh != 12) {
                    hh += 12;
                }
                if(!isPM && hh == 12) {
                    hh -= 12;
                }

                return hh+':'+mm;
            }

            return time;
        }
    }
}